import { HttpStatusCode } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MyCompetenceService } from 'src/app/services/my-competence.service';

@Component({
    selector: 'app-create-mycompetence',
    templateUrl: './create-mycompetence.component.html',
    styleUrl: './create-mycompetence.component.scss',
    standalone: false
})
export class CreateMyCompetenceComponent {
  courseId: string = '';

  constructor(
    private router: Router,
    private myCompetenceService: MyCompetenceService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  submit() {
    this.myCompetenceService.getMyCompetenceTraining(this.courseId)
     .subscribe({
      next: myCompetenceTraining => {
        const encodedModel = encodeURIComponent(JSON.stringify(myCompetenceTraining));
        this.router.navigate(['manage-elearning', 'edit', 'new'], {
          queryParams: { data: encodedModel }
        });
      },
      error: err => {
        if (err.status === HttpStatusCode.NotFound) {
          this.toastrService.error(
            this.translateService.instant('MY-COMPETENCE.MY-COMPETENCE-NOT-FOUND')
          );
        } else {
          this.toastrService.error(
            this.translateService.instant('COMMON.AN-ERROR-HAS-OCCURRED')
          );
        }
        this.courseId = '';
      }
      });
  }

  cancel() {
    this.router.navigate(['manage-elearning', 'edit', 'new']);
  }
}

